import styled from '@emotion/styled';
import { gsap } from 'gsap';
import { useState, useLayoutEffect, useRef } from 'react';

import { animateSVGPath } from '@components/Sections/utils/animations';
import { PenLine } from '@features';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const TitlePenUnderline: React.FC = () => {
  const [titlePenUnderlinePathLength, setTitlePenUnderlinePathLength] = useState(0);
  const titlePenUnderlineRef = useRef<SVGPathElement | null>(null);

  useLayoutEffect(() => {
    const titlePenUnderlineEl = titlePenUnderlineRef.current;

    if (!titlePenUnderlineEl) {
      return;
    }

    const ctx = gsap.context(() => {
      const penPathLength = titlePenUnderlineEl.getTotalLength();
      setTitlePenUnderlinePathLength(penPathLength);
      animateSVGPath({
        animationTarget: titlePenUnderlineEl,
        animationTrigger: titlePenUnderlineEl,
        animationStartPositions: 'top 35%',
        pathLength: penPathLength,
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <PenUnderline width="488" height="9" viewBox="0 0 488 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.15798 2.39803C11.5038 2.18389 24.4242 1.32418 34.7695 1.40849C48.0405 1.51664 61.1386 3.57743 74.3894 3.30317C96.3708 2.8482 118.092 7.00853 139.998 6.55513C154.056 6.26416 161.299 5.25346 175.324 5.84396C192.456 6.56527 221.404 4.28199 238.555 3.92702C265.45 3.37033 287.228 8.11767 314.174 7.55996C371.554 6.37231 428.912 7.02908 486.314 5.84097"
        stroke="#D9FC51"
        strokeWidth="2"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
        strokeDasharray={`${titlePenUnderlinePathLength} ${titlePenUnderlinePathLength}`}
        ref={titlePenUnderlineRef}
      />
    </PenUnderline>
  );
};

export const PenUnderline = styled(PenLine)`
  ${getMediaqueryStyled('xl')} {
    width: 366px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 243px;
  }
`;
